<template>
  <div class="textarea-container">
    <textarea
      class="input-textarea"
      :value="modelValue"
      @input="input($event.target)"
      v-bind="$attrs"
      :class="{error:error}"
      :rows="rows"
    ></textarea>
    <p class="input-error" v-if="error">{{ error }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: ['modelValue', 'error', 'rows'],
  emits:['update:modelValue'],
  setup(props, context) {
    const rows = props.rows ? props.rows : 5
    const input = (target: EventTarget  | null) => {
      target as HTMLTextAreaElement
      if(target instanceof HTMLTextAreaElement){
        context.emit('update:modelValue', target.value)
      }
    }
    return {
      input,
      rows
    }
  }
})
</script>
